import { render, staticRenderFns } from "./_Servicos_mais_cotados.vue?vue&type=template&id=066f4f2f&scoped=true&"
import script from "./_Servicos_mais_cotados.vue?vue&type=script&lang=js&"
export * from "./_Servicos_mais_cotados.vue?vue&type=script&lang=js&"
import style0 from "./_Servicos_mais_cotados.vue?vue&type=style&index=0&id=066f4f2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f4f2f",
  null
  
)

export default component.exports